
import "../../common/Focusable/Focusable.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_ButtonCore";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_ButtonCore__root","content":"wds_1_180_0_ButtonCore__content","prefix":"wds_1_180_0_ButtonCore__prefix","suffix":"wds_1_180_0_ButtonCore__suffix"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




